// Mock data for Cabinet Hero

export const services = [
  {
    id: 1,
    title: 'Cabinet Refacing',
    description: 'Transform your kitchen with new CNC-cut doors, drawers, and panels. Get a fresh look without the cost of full replacement.',
    price: '$300/linear foot',
    avgCost: '$7,000 - $14,000',
    features: ['Custom CNC-cut doors', 'Premium finishes', 'Soft-close hardware', 'Fast turnaround', 'Professional installation'],
    icon: 'layers'
  },
  {
    id: 2,
    title: 'Cabinet Refinishing',
    description: 'Professional spray booth refinishing for a flawless, durable result. Transform your existing cabinets with premium paints and stains.',
    price: '$200-$400/door',
    avgCost: '$5,000 - $12,000',
    features: ['Spray booth quality', 'Multiple finish options', '2-tone available', 'Durable coating', 'Fast turnaround'],
    icon: 'paintbrush'
  },
  {
    id: 3,
    title: 'Cabinet Replacement',
    description: 'Full cabinet carcasses and modular sections with precision CNC manufacturing. Built to last with premium materials.',
    price: '$600-$1,500/box',
    avgCost: '$20,000 - $50,000',
    features: ['Custom carcasses', 'Modular design', 'Professional install', 'Paint booth finish', 'Lifetime warranty'],
    icon: 'package'
  },
  {
    id: 4,
    title: 'Cabinet Repair',
    description: 'Expert repairs for damaged doors, drawers, hinges, and hardware. Quick fixes that restore function and beauty to your cabinets.',
    price: 'Starting at $150',
    avgCost: '$150 - $2,000',
    features: ['Same-day service', 'Hardware replacement', 'Door/drawer fixes', 'Hinge adjustments', 'Expert technicians'],
    icon: 'wrench'
  },
  {
    id: 5,
    title: 'Cabinet Adjustments',
    description: 'Professional cabinet alignment, leveling, and fine-tuning services. Perfect for doors that don\'t close properly or uneven cabinets.',
    price: 'Starting at $150',
    avgCost: '$150 - $800',
    features: ['Door alignment', 'Hinge adjustments', 'Cabinet leveling', 'Drawer track repair', 'Quick service'],
    icon: 'settings'
  }
];

export const inspirationGallery = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1601760561441-16420502c7e0?w=800&q=80',
    title: 'Classic White Shaker',
    style: 'Traditional Shaker Doors with Raised Panels',
    category: 'White Shaker'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1701421047855-d7bafd8d6f69?w=800&q=80',
    title: 'Two-Tone Elegance',
    style: 'White Cabinets with Dark Island Contrast',
    category: 'Two-Tone'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1618321331798-6c89635802ad?w=800&q=80',
    title: 'Navy Blue Contemporary',
    style: 'Deep Navy Flat Panel Cabinets',
    category: 'Modern'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1631048498692-af6262577031?w=800&q=80',
    title: 'Glass Door Showcase',
    style: 'Upper Cabinets with Glass Fronts',
    category: 'Glass Doors'
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1610733374054-59454fe657cd?w=800&q=80',
    title: 'Natural Wood Warmth',
    style: 'Modern Wood Grain with Clean Lines',
    category: 'Natural Wood'
  },
  {
    id: 6,
    image: 'https://images.unsplash.com/photo-1665507279638-5b48073c637b?w=800&q=80',
    title: 'Modern Gray',
    style: 'Contemporary Gray Flat Panel Design',
    category: 'Modern'
  },
  {
    id: 7,
    image: 'https://images.unsplash.com/photo-1592506119503-c0b18879bd5a?w=800&q=80',
    title: 'Sleek Flat Panel',
    style: 'Minimalist Handleless Design',
    category: 'Modern'
  },
  {
    id: 8,
    image: 'https://images.unsplash.com/photo-1622372738946-62e02505feb3?w=800&q=80',
    title: 'Mixed Material Design',
    style: 'Wood and White Two-Tone Combination',
    category: 'Two-Tone'
  },
  {
    id: 9,
    image: 'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?w=800&q=80',
    title: 'Bright White Modern',
    style: 'Clean White Cabinets with Modern Hardware',
    category: 'White Shaker'
  },
  {
    id: 10,
    image: 'https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?w=800&q=80',
    title: 'Open Concept Kitchen',
    style: 'Light Cabinets with Open Layout',
    category: 'Modern'
  }
];

// Remove transformations - keeping only inspiration gallery
export const transformations = [];
export const gallery = inspirationGallery; // For backward compatibility

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    location: 'Birmingham, MI',
    rating: 5,
    text: 'Cabinet Hero refaced our kitchen cabinets and they look absolutely stunning! The CNC precision doors fit perfectly and the finish is flawless.',
    service: 'Cabinet Refacing'
  },
  {
    id: 2,
    name: 'John Anderson',
    location: 'Troy, MI',
    rating: 5,
    text: 'Professional, fast, and affordable. Our new cabinets look amazing and cost half of what we expected to pay!',
    service: 'Cabinet Replacement'
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    location: 'Royal Oak, MI',
    rating: 5,
    text: 'They fixed our broken cabinet doors and adjusted all the hinges for only $150. Everything closes smoothly now. Highly recommend!',
    service: 'Cabinet Repair & Adjustments'
  }
];

export const pricingOptions = [
  { label: 'Cabinet Refacing', value: 'refacing', rate: 300, unit: 'linear foot' },
  { label: 'Cabinet Refinishing', value: 'refinishing', rate: 300, unit: 'door' },
  { label: 'Cabinet Replacement', value: 'replacement', rate: 1000, unit: 'box' },
  { label: 'Cabinet Repair', value: 'repair', rate: 150, unit: 'visit' },
  { label: 'Cabinet Adjustments', value: 'adjustments', rate: 150, unit: 'visit' }
];

export const mockQuotes = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john@example.com',
    phone: '555-0123',
    service: 'Cabinet Refacing',
    projectSize: '20 linear feet',
    message: 'Looking to reface kitchen cabinets',
    status: 'new',
    date: '2025-01-15T10:30:00Z'
  },
  {
    id: 2,
    name: 'Jane Smith',
    email: 'jane@example.com',
    phone: '555-0456',
    service: 'Cabinet Replacement',
    projectSize: '15 boxes',
    message: 'Full kitchen replacement needed',
    status: 'contacted',
    date: '2025-01-14T14:20:00Z'
  },
  {
    id: 3,
    name: 'Mike Johnson',
    email: 'mike@example.com',
    phone: '555-0789',
    service: 'Cabinet Repair',
    projectSize: '3 doors',
    message: 'Need repair on broken cabinet doors',
    status: 'completed',
    date: '2025-01-10T09:15:00Z'
  }
];